import React, { useEffect, useState } from "react";
import _ from "lodash";
import Form from "forms/Form";
import formWrapper from "hoc/formWrapper";
import { InlineNotification, Loading, Tag } from "carbon-components-react";
import { consoleLog, getAppIdFormField } from "utils/functions";
import { DOMAINS, REGISTER } from "api/config/endpoints";
import { DOMAIN_REGISTRATION_DEFAULT_YEARS } from "api/config/constants";
import useUser from "hooks/useUser";

const RegisterDomainForm = ({ onUpdateDomainName, ...props }) => {
    const [saving, setSaving] = useState(false);
    const [errors, setErrors] = useState();
    const [report, setReport] = useState();
    const [defaultValues, setDefaultValues] = useState({});
    const [isFqdn, setIsFqdn] = useState();

    const { userIsDev } = useUser()

    useEffect(() => {
        updateIsFqdn(props.defaultValues?.domain_name)
        setDefaultValues(props.defaultValues)
    }, [props.defaultValues])

    const getValue = (name, type) => {
        const value = !_.isEmpty(defaultValues) ? defaultValues[name] : null;
        return value;
    };

    const getEndpoint = () => {
        return [DOMAINS, REGISTER].join("/")
    }

    const updateIsFqdn = (value) => {
        if (!value) {
            setIsFqdn(false)
        }
        else {
            setIsFqdn(value.match(/^(?!\-)(?:(?:[a-zA-Z\d][a-zA-Z\d\-]{0,61})?[a-zA-Z\d]\.){1,126}(?!\d+)[a-zA-Z\d]{1,63}$/i))
        }
    }

    const onSubmit = async (e) => {
        setReport()
        setErrors()
        consoleLog("client.get onSubmit", e)
        if (e.status) {
            setReport(["The domain registration process has started for domain name " + getValue("domain_name")])
        }
        else {
            setErrors(["Something went wrong during the domain registration. Please contact support"])
        }
        if (props.onSubmit) {
            props.onSubmit()
        }
    }

    const getFormatAwsAppsOptions = (awsApps) => {

        return awsApps ? awsApps.map(item => {
            return {
                id: String(item.id),
                label: `${item.region_name} v${item.version} (${item.region_id} / ${item.description})`
            }
        }) : []
    }

    let fields = [
        {
            elementType: "domain",
            id: "domain_name",
            name: "domain_name",
            labelText: `Domain name`,
            value: getValue("domain_name"),
        }
    ];

    if (props.userIsSuperAdmin) {
        if (!props.hideAppId) {
            fields.push(getAppIdFormField({ isAdmin: true, awsApps: props.awsApps, getValue, fieldName: "aws_amplify_app_id" }))
            // fields.push(
            //     {
            //         elementType: "select",
            //         //   helperText: "Timezone",
            //         id: "aws_amplify_app_id",
            //         name: "aws_amplify_app_id",
            //         label: "AWS App",
            //         //   invalidText: "This must be a valid email address",
            //         labelText: "Registration form (Leave blank to use default)",
            //         value: getValue("aws_amplify_app_id"),
            //         items: getFormatAwsAppsOptions(props.awsApps),
            //     }
            // )
        }
        fields.push(
            {
                elementType: "input",
                id: "years",
                name: "years",
                label: "Years",
                labelText: "Years",
                value: getValue("years") || DOMAIN_REGISTRATION_DEFAULT_YEARS,
            }
        )
    }
    else {
        fields.push({
            elementType: "toggle",
            id: "attach_to_adam",
            name: "attach_to_adam",
            labelText: "Attach to ADaM?",
            value: getValue("attach_to_adam", "bool"),
            labelOff: "The domain will simply be registered but not associated with ADaM", //labelA
            labelOn: "After being registered the domain will be associated with ADaM", //labelB
        })

        if (getValue("attach_to_adam", "bool")) {
            fields.push(getAppIdFormField({ isAdmin: false, getValue, fieldName: "aws_amplify_app_id" }))
        }
        else {
            fields.push(
                {
                    elementType: "select",
                    //   helperText: "Timezone",
                    id: "years",
                    name: "years",
                    label: "Years",
                    //   invalidText: "This must be a valid email address",
                    labelText: "Years",
                    value: getValue("years"),
                    items: [
                        {
                            id: "1",
                            label: `1 Year`
                        },
                        {
                            id: "3",
                            label: `3 Years`
                        },
                    ],
                }
            )
        }
    }

    fields.push({
        elementType: "input",
        id: "one_time_password",
        name: "one_time_password",
        labelText: "Insert your one time password",
        placeholder: "One time password",
        value: getValue("one_time_password"),
        rules: {
            required: true,
        },
    })

    const onChange = (key, value) => {
        console.log("onChange", key, value)
        if (key === "domain_name") {
            console.log("onChange fqdn", value.match(/^(?!\-)(?:(?:[a-zA-Z\d][a-zA-Z\d\-]{0,61})?[a-zA-Z\d]\.){1,126}(?!\d+)[a-zA-Z\d]{1,63}$/i))
            setIsFqdn(value.match(/^(?!\-)(?:(?:[a-zA-Z\d][a-zA-Z\d\-]{0,61})?[a-zA-Z\d]\.){1,126}(?!\d+)[a-zA-Z\d]{1,63}$/i))
            onUpdateDomainName(value)
        }
        setDefaultValues({
            ...defaultValues,
            [key]: value
        });
    }

    const onSavingChange = (value) => {
        setSaving(value)
    }

    let extraContents = [];
    const domainName = getValue("domain_name")
    if (domainName) {
        if (!isFqdn) {
            extraContents.push(
                <Tag type="red">
                    This is not a valid domain name
                </Tag>
            )
        }
        // else if (isFqdn) {
        //     extraContents.push(
        //         <Tag type="green">
        //             This is a valid Fully qualifiied DOMAIN
        //         </Tag>
        //     )
        // }

        if (report) {
            extraContents = [
                ...extraContents,
                ...report?.map(msg => <>{msg}</>)
            ]
            extraContents.push(
                <InlineNotification
                    kind="success"
                    hideCloseButton={true}
                    lowContrast={true}
                    title={"Registering " + domainName}
                    subtitle={report?.map(msg => <>{msg}</>)}
                />
            )
        }

    }

    if (errors) {
        extraContents.push(
            // <div className="form-error__text">
            //     {errors}
            // </div>
            <InlineNotification
                kind="error"
                hideCloseButton={true}
                lowContrast={true}
                title="Something went wrong"
                subtitle={errors}
            />
        )
    }

    return (
        <div className={props.className}>
            {
                saving ? <Loading /> : null
            }
            {
                // !userIsDev() ? <div style={{padding: "3rem 1rem"}}>
                //         <Tag type="red">You are not authorised to do this action, this operation is reserved for dev only</Tag>
                //     </div> : 
                (
                    <Form
                        fields={fields}
                        extra={fields}
                        endpoint={getEndpoint()}
                        loaded={true}
                        modal={props.modal}
                        onRequestClose={props.onRequestClose}
                        onSavingChange={(value) => onSavingChange(value)}
                        onChange={(key, val) => onChange(key, val)}
                        onSubmit={(e) => onSubmit(e)}
                        extraContents={(
                            <>
                                <div style={{ marginBottom: "0.5rem" }}>
                                    Please remember:<br />
                                    <strong>DO NOT REGISTER SUBDOMAINS!</strong><br />
                                    In case of the requested domain for the event is <em>registration.event-domain.com</em> you have to register <em>event-domain.com</em>
                                </div>
                                <div style={{ marginBottom: "1rem", color: "red" }}>
                                    Please remember that this operation requires a <strong>payment</strong>, so before confirming make sure that the domain name is correct
                                </div>
                            </>
                        )}
                        extraFieldsAfter={extraContents}
                        primaryButtonText={"Register"}
                        submitButtonDisabled={!isFqdn}
                    />
                )}
        </div>
    );
};

export default formWrapper(RegisterDomainForm);
